/**
 * Pagination styles available for the pagination component.
 */
export enum PaginationStyle {
  /** Default pagination style with numbered pages. */
  DEFAULT = 0,
  /** Simple pagination style with basic navigation controls. */
  SIMPLE = 1,
  /** Load more style for pagination. */
  LOAD_MORE = 2,
  /** Infinite scroll style for pagination (only available in grid mode). */
  INFINITE_SCROLL = 3
}
